import { useResizeObserver } from 'beautiful-react-hooks'
import { type EditorView } from 'prosemirror-view'
import { useLayoutEffect, useRef } from 'react'

/**
 * Returns the DOMRect of the editor HTMLElement, and updates this value whenever that changes (e.g. it is resized).
 * @param view EditorView
 * @returns DOMRect of editorView.dom (typically the `.ProseMirror` element)
 */
export function useDocRect(view?: EditorView) {
  const ref = useRef<HTMLElement>()
  const DOMRect = useResizeObserver(ref)

  useLayoutEffect(() => {
    if (view?.dom) {
      ref.current = view.dom as HTMLElement
    }
  }, [view])

  return DOMRect
}
